"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));
var _react = _interopRequireDefault(require("react"));
var _clsx3 = _interopRequireDefault(require("clsx"));
var _inputMessages = _interopRequireDefault(require("./input-messages"));
var propTypes = _interopRequireWildcard(require("./mini-dealer-locator.prop-types"));
var _inputSearch = require("./input-search.utils");
var _inputSearch2 = _interopRequireDefault(require("./input-search.css"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var id = 1;
var InputSearch = /*#__PURE__*/function (_React$Component) {
  (0, _inheritsLoose2["default"])(InputSearch, _React$Component);
  function InputSearch(props) {
    var _this;
    _this = _React$Component.call(this, props) || this;
    _this.state = {
      value: props.value || '',
      focused: false
    };
    _this.inputId = props.id || "mini-dealer-locator-input-" + id;
    _this.handleClear = _this.handleClear.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleChange = _this.handleChange.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleInputBlur = _this.handleInputBlur.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleInputFocus = _this.handleInputFocus.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleSearch = _this.handleSearch.bind((0, _assertThisInitialized2["default"])(_this));
    id += 1;
    return _this;
  }
  var _proto = InputSearch.prototype;
  _proto.handleClear = function handleClear() {
    var onClear = this.props.onClear;
    this.setState({
      value: ''
    });
    if (onClear) {
      onClear();
    }
  };
  _proto.handleChange = function handleChange(e) {
    var onChange = this.props.onChange;
    this.setState({
      value: e.target.value
    });
    if (onChange) {
      onChange(e.target.value);
    }
  };
  _proto.handleInputBlur = function handleInputBlur() {
    this.setState({
      focused: false
    });
  };
  _proto.handleInputFocus = function handleInputFocus() {
    this.setState({
      focused: true
    });
  };
  _proto.handleSearch = function handleSearch() {
    var onSearch = this.props.onSearch;
    var value = this.state.value;
    if (onSearch) {
      onSearch(value);
    }
  };
  _proto.render = function render() {
    var _clsx, _clsx2;
    var _this$props = this.props,
      theme = _this$props.theme,
      label = _this$props.label,
      messages = _this$props.messages,
      inputRef = _this$props.inputRef,
      error = _this$props.error,
      controlled = _this$props.controlled;
    var _this$state = this.state,
      focused = _this$state.focused,
      value = _this$state.value;
    var isError = error || (0, _inputSearch.hasErrorMessages)(messages);
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: _inputSearch2["default"].searchField
    }, /*#__PURE__*/_react["default"].createElement("label", {
      htmlFor: this.inputId,
      className: (0, _clsx3["default"])(theme.labelSmall, _inputSearch2["default"].label, (_clsx = {}, _clsx[_inputSearch2["default"].moveLabelOverField] = !value && !focused, _clsx))
    }, label), /*#__PURE__*/_react["default"].createElement("input", {
      ref: inputRef,
      id: this.inputId,
      type: "text",
      onChange: this.handleChange,
      className: (0, _clsx3["default"])(theme.inputsAndOptions, _inputSearch2["default"].textInput, (_clsx2 = {}, _clsx2[_inputSearch2["default"].textInputError] = isError, _clsx2)),
      placeholder: "",
      onBlur: this.handleInputBlur,
      onFocus: this.handleInputFocus,
      value: controlled ? value : undefined
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: _inputSearch2["default"].ctaContainer
    }, value && /*#__PURE__*/_react["default"].createElement("button", {
      type: "button",
      className: _inputSearch2["default"].clearButton,
      onClick: this.handleClear,
      "aria-label": "clear button"
    }), /*#__PURE__*/_react["default"].createElement("button", {
      type: "button",
      className: _inputSearch2["default"].submitSearchButton,
      onClick: this.handleSearch,
      "aria-label": "search button"
    })), isError && /*#__PURE__*/_react["default"].createElement(_inputMessages["default"], {
      messages: messages,
      theme: theme
    }));
  };
  return InputSearch;
}(_react["default"].Component);
InputSearch.defaultProps = {
  controlled: true
};
var _default = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  return /*#__PURE__*/_react["default"].createElement(InputSearch, (0, _extends2["default"])({}, props, {
    inputRef: ref
  }));
});
exports["default"] = _default;